import { Scrollbars } from "react-custom-scrollbars";
import styled from "styled-components";

export const Modulo = styled.div`
  position: relative;
  width: 2.5em;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 0.625rem 0.625rem 0 0;
  
  .modulo-button {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

export const ModuloScroll = styled(Scrollbars)``;